import { reduceKeysFromObjectArray } from '../../../utils/utils'

const TransformData = (reviewsServerData: []) => {
  const keysToKeep = ['rating', 'title', 'comment', 'submittedAt', 'id'];

  return reduceKeysFromObjectArray(reviewsServerData, keysToKeep)
}

export default TransformData
